import React, { useState } from 'react'
import { Box, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import {
  StyledToggleButton,
  StyledToggleButtonGroup,
} from 'components/DrillCard/components/StyledComponents'
import { Translate } from 'react-localize-redux'
import fallbackImageUrl from '../../../assets/images/login-coach.jpg'
import useStyles from '../styles'
import { DialogContent } from './StyledComponents'

const ArticleBody = ({ article }) => {
  const classes = useStyles()
  const [selectedTab, setSelectedTab] = useState('image')

  const isPodcastOrVideo = article.type !== 'article'

  const handleTabChange = (event, newValue) => {
    if (newValue) {
      setSelectedTab(newValue)
    }
  }

  return (
    <DialogContent className={classes.dialogContent}>
      <Grid
        container
        spacing={5}
        className={classes.gridContainer}
      >
        <Grid item md={6} xs={12} className={classes.mediaSection}>
          <Box className={classes.contentContainer}>
            {isPodcastOrVideo && (
              <Box display="flex" justifyContent="center" mb={2}>
                <StyledToggleButtonGroup
                  value={selectedTab}
                  exclusive
                  onChange={handleTabChange}
                  aria-label="media type"
                >
                  <StyledToggleButton value="image" aria-label="image">
                    <Translate id="drills.drawing" />
                  </StyledToggleButton>
                  <StyledToggleButton value="video" aria-label="video">
                    <Translate id="drills.video" />
                  </StyledToggleButton>
                </StyledToggleButtonGroup>
              </Box>
            )}
            {selectedTab === 'image' && (
              <Box className={classes.imageContainer}>
                <img
                  src={
                    article.relationships.thumbnail?.full_url ||
                    fallbackImageUrl
                  }
                  alt="Article"
                  className={classes.image}
                />
              </Box>
            )}
            {selectedTab === 'video' && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
              >
                {article.type === 'podcast' && (
                  <audio controls style={{ width: '80%' }}>
                    <source
                      src={article.content?.podcast?.full_url}
                      type="audio/mpeg"
                    />
                    <track kind="captions" />
                    Your browser does not support the audio element.
                  </audio>
                )}
                {article.type === 'video' && (
                  <video controls style={{ width: '80%' }} preload="metadata">
                    <source
                      src={article.content?.video?.full_url}
                      type="video/mp4"
                    />
                    <track kind="captions" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item md={6} xs={12} className={classes.detailsSection}>
          {article.content.body && (
            <Box
              component="div"
              dangerouslySetInnerHTML={{ __html: article.content.body }}
            />
          )}
        </Grid>
      </Grid>
    </DialogContent>
  )
}

ArticleBody.propTypes = {
  article: PropTypes.shape().isRequired,
}

export default ArticleBody
